import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ComparisonHeader = ({ propertyCount, onClearAll }) => {
  const navigate = useNavigate();

  return (
    <div
      className="sticky top-0 z-40 px-4 md:px-6 lg:px-8 py-4"
      style={{ background: '#0A1628', borderBottom: '1px solid rgba(0, 212, 255, 0.15)' }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <button
            onClick={() => navigate('/search-results')}
            className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all"
            style={{ color: '#8BA5C0', border: '1px solid rgba(0, 212, 255, 0.15)' }}
            onMouseEnter={e => e.currentTarget.style.color = '#00D4FF'}
            onMouseLeave={e => e.currentTarget.style.color = '#8BA5C0'}
          >
            <Icon name="ArrowLeft" size={16} color="currentColor" />
            Back to Search
          </button>

          <div className="flex items-center gap-2">
            <div
              className="flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold"
              style={{ background: 'rgba(0, 212, 255, 0.2)', color: '#00D4FF', border: '1px solid rgba(0, 212, 255, 0.4)' }}
            >
              {propertyCount}
            </div>
            <div>
              <h1 className="text-lg font-bold text-white">Property Comparison</h1>
              <p className="text-xs" style={{ color: '#6B9EC4' }}>
                Comparing {propertyCount} {propertyCount === 1 ? 'property' : 'properties'}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <span
            className="hidden md:inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold"
            style={{ background: 'rgba(0, 212, 255, 0.1)', color: '#00D4FF', border: '1px solid rgba(0, 212, 255, 0.25)' }}
          >
            <Icon name="Zap" size={12} color="currentColor" />
            AI-Powered Analysis
          </span>
          <button
            onClick={onClearAll}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all"
            style={{ color: '#FF6B6B', border: '1px solid rgba(255, 107, 107, 0.25)' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255, 107, 107, 0.1)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            <Icon name="Trash2" size={14} color="currentColor" />
            Clear All
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComparisonHeader;
